// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import type { TFunction } from 'i18next';
const SEGMENT_KEY_MAP: Record<string, string> = {
  'Total Market': 'total-market',
  'Investment Grade': 'investment-grade',
  'Large Cap': 'large-cap',
};
export const transformAssetClassData = (
  categories: string[],
  percentage: number[],
  t?: (key: string) => string,
) => {
  const colorsCount = categories.length;

  const maxColor = 0.9;
  const minColor = 0.3;

  let step: number;

  if (colorsCount > 1) {
    step = (maxColor - minColor) / (colorsCount - 1);
  } else {
    /* istanbul ignore next */
    step = maxColor;
  }

  const colors = Array.from({ length: colorsCount }, (_, index) =>
    (maxColor - index * step).toFixed(2),
  );

  const sortedData = categories
    .map((_, index) => ({
      category: categories[index],
      percentage: percentage[index],
    }))
    .sort((a, b) => b.percentage - a.percentage);

  const children = sortedData.map((data, index) => {
    const color = `hsla(205, 84%, 40%, ${colors[index]})`;
    const percentageValue = data.percentage / 100;

    return {
      name:
        SEGMENT_KEY_MAP[data.category] && t
          ? t(`common.${SEGMENT_KEY_MAP[data.category]}`)
          : data.category,
      color,
      percentage: percentageValue,
    };
  });

  return {
    name: 'Asset Class',
    color: 'hsla(205, 84%, 40%, 0.75)',
    children,
  };
};

export const formatAssetClassLabel = (length: number) => {
  const label: ((e: any) => string) | 'id' =
    length > 4
      ? 'id'
      : (e: any) => e.id + ' (' + e.formattedValue.replace(/\.[0-9]+%/g, '%') + ')';

  return label;
};
